import ReactHeight from 'react-height';

import { PureFunctional, React } from '../../react';

import cx from './style.less';

export interface IPanelProps {
  active?: boolean;
  idx?: number;
  label?: string;
  offsetX?: number;
  className?: string;
  onHeightReady?: (idx: number, height: number) => void;
}

const percentageMul = -100;

export default PureFunctional<any | IPanelProps>(`SlideViewPanel`)(
  ({
    active,
    className,
    children,
    idx,
    offsetX,
    onHeightReady,
  }) => (
    <div className={cx('panel', className, { active })} style={{ transform: `translateX(${offsetX * percentageMul}%)` }}>
      <ReactHeight onHeightReady={(h: number) => onHeightReady(idx, h)}>
        {children}
      </ReactHeight>
    </div>
  ));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/slideView/panel.tsx